import React, { Component } from 'react';

import styles from './styles.less';

interface Props {
	children: React.ReactNode;
}

export default class FormFieldError extends Component<Props> {
	render() {
		return (
			<p className={styles.error} data-testid='form-field-error'>
				{this.props.children}
			</p>
		);
	}
}
